import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
} from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";

/** One layout for the last confirmed rail and its live account controls. */
export function AccountRailLayout({
  organization,
  products,
  resources,
  actions,
  user,
}: {
  organization: React.ReactNode;
  products: React.ReactNode;
  resources: React.ReactNode;
  actions: React.ReactNode;
  user: React.ReactNode;
}) {
  return (
    <Sidebar
      collapsible="none"
      className="w-12 shrink-0 border-r md:!w-[calc(var(--sidebar-width-icon)_+_1px)]"
    >
      <SidebarHeader data-rail-key="organization">{organization}</SidebarHeader>
      <SidebarContent className="lb-scrollbar-overlay">
        {products}
        <Separator data-rail-key="separator" className="mx-auto w-8" />
        {resources}
        {actions}
      </SidebarContent>
      <SidebarFooter data-rail-key="user">{user}</SidebarFooter>
    </Sidebar>
  );
}
